<template>
  <div id="ImageUpload">
    <div class="upload_pic clearfix">
      <div class="upload_pic_item"
           v-for="(item,i) of picDataArr"
           :key="item"
           @click="select(i)">
        <img :src="item"
             alt
             @load="onPreviewImageLoad(i)"/>
        <span>
          <slot name="select"
                :isActive="Active(i)"></slot>
        </span>
        <span @click="delPic(i)"
              class="del">
          <slot name="del"></slot>
        </span>
      </div>
      <div class="upload_file"
           v-show="isshow">
        <input type="file"
               name="file"
               accept="image/*"
               @change="upload"
               ref="file"
               :multiple="multiple" />
        <img class="file"
             :src="src"
             ref="img"
             alt />
        <slot name="limitImg"></slot>
      </div>
    </div>
    <div>
      <div class="make"
           id='overlay'
           v-if="show"><span class="makeFont">加载中...</span></div>
    </div>
  </div>
</template>
<script>
import { newUploadImage } from "../../../../../api/index"
export default {
  data () {
    return {
      // height: "",
      dataArr: [],//压缩
      picDataArr: this.picImgs,//不压缩
      isshow: true,
      activeIndex: '',
      isActive: false,
      show: false,
      imageName: this.subNodeName,
      nodeNameStr: this.nodeName,
    };
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    qe: {
      type: Boolean,
      default: false
    },
    AspectRatio: {
      type: Number,
      default: 1
    },
    src: {
      type: String,
    },
    picIsshow: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Boolean,
      default: false
    },
    isOne: {
      type: Boolean,
      default: false
    },
    picImgs: {
      type: Array,
      default () {
        return []
      }
    },
    nodeName: {
      type: String,
    },
    subNodeName: {
      type: String,
    },
  },
  watch: {
    picImgs (n) {
      this.picDataArr = n;
      //console.log("picImgs", this.picDataArr);
    },
    nodeName (n) {
      this.nodeNameStr = n;
      //console.log("picImgs", this.picDataArr);
    },
    subNodeName (n) {
      this.imageName = n;
      //console.log("picImgs", this.picDataArr);
    }
  },
  methods: {
    Active (i) {
      return i === this.activeIndex
    },
    delPic (i) {
      this.picDataArr.splice(i, 1);
      this.$emit("getDataArrPic", this.nodeNameStr, this.imageName, this.picDataArr);
      if (!this.picIsshow) {
        this.isshow = true;
      }
    },
    select (i) {
      if (this.activeIndex === i) {
        this.activeIndex = -1
        this.isActive = false
      } else {
        this.activeIndex = i;
        this.isActive = true
      }
      this.$emit('selected', this.activeIndex, this.isActive)
    },
    async postImg (file, files) {
      // 需要压缩
      //   let thumForm = new FormData()
      //   thumForm.append("file", file)
      //   thumForm.append("isThumb", true)
      //   let thumpicRes = await newUploadImage(thumForm)
      //   if ((thumpicRes.Type == "Success")) {
      //     let url;
      //     if (process.env.NODE_ENV == "development") {
      //       url = "https://www.iduilv.com" + thumpicRes.Data;
      //     } else {
      //       url = thumpicRes.Data;
      //     }
      //     if (this.isOne) {
      //       this.dataArr = [url]
      //     } else {
      //       this.dataArr.push(url);
      //     }
      //     if (this.limit && this.dataArr.length > 9) {
      //       this.$layer.alert("不能超过9张图片");
      //       this.dataArr.splice(9);
      //       this.$emit("loadingHide")
      //     }
      //     this.$emit("getDataArr", this.dataArr);
      //     this.$refs.file.value = null;
      //     if (!this.picIsshow) {
      //       this.isshow = false;
      //     }

      //   }
      //   if (thumpicRes.Type == "Error" || thumpicRes.Type == "Warning") {
      //     return this.$layer.alert(thumpicRes.Content);
      //   }

      // 不需要压缩
      let picForm = new FormData()
      picForm.append("file", file)
      picForm.append("isThumb", false)
      let picRes = await newUploadImage(picForm)
      if ((picRes.Type == "Success")) {
        let url;
        if (process.env.NODE_ENV == "development") {
          url = "https://www.iduilv.com" + picRes.Data;
        } else {
          url = picRes.Data;
        }
        if (this.isOne) {
          this.picDataArr = [url]
        } else {
          this.picDataArr.push(url);
        }
        if (this.limit && this.picDataArr.length > 9) {
          this.$layer.alert("不能超过9张图片");
          this.picDataArr.splice(9);
          this.$emit("loadingHide")
        }
        this.$emit("getDataArrPic", this.nodeNameStr, this.imageName, this.picDataArr);
        this.$refs.file.value = null;
        if (!this.picIsshow) {
          this.isshow = false;
        }
      }
      if (picRes.Type == "Error" || picRes.Type == "Warning") {
        this.$layer.alert(picRes.Content);
        this.show = false;
        return;
      }

      var className = document.getElementsByClassName('upload_pic_item').length
      if (className == this.picDataArr.length || this.qe == false) {
        this.show = false
      }
    },
    upload (e) {
      let files = e.target.files;
      let that = this;
      this.show = true
      for (let i = 0; i < files.length; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = function () {
          that.postImg(files[i], files.length);
        };
      }

    },
    // uploadImgLoad () {
    //   this.height = this.$refs.img.offsetHeight + "px";
    // },
    // 预览图加载后，自动调整容器高度
    onPreviewImageLoad(index) {

      const container = this.$el.querySelectorAll('.upload_pic_item')[index];
      if (container) {
        container.style.height = 'auto'; // 让高度由内容决定
      }
    },
    //调整所有预览图片容器的高度
    adjustPreviewHeights() {
      const containers = this.$el.querySelectorAll('.upload_pic_item');
      containers.forEach((container, index) => {
        const img = container.querySelector('img');
        if (img && img.complete && container) { // 增加非空判断  图片已加载完成
          container.style.height = 'auto';
        }
      });
    },
  },
  mounted () {
    // 初始化时触发高度调整
    this.$nextTick(() => {
      this.adjustPreviewHeights();
    });
  }
};
</script>
<style scoped>
@import '../../../../../html/components/imageUpload/ImageUpload.css';
#overlay {
  background: #000;
  opacity: 0.5; /* 透明度 */
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 100; /* 此处的图层要大于页面 */
}
.makeFont {
  color: #fff;
  margin-top: 25%;
  display: inline-block;
  margin-left: 44%;
  font-size: 12px;
}
/* 添加基础样式确保高度正确 */
::v-deep .upload_pic_item {
  height: auto !important; /* 强制高度由内容决定 */
  min-height: 80px; /* 保底高度，避免完全塌陷 */
  display: inline-block; /* 确保容器能包裹内容 */
  position: relative;
}

::v-deep .upload_pic_item img {
  width: 100%; /* 适应容器宽度 */
  height: auto; /* 保持图片比例 */
  display: block; /* 消除底部间隙 */
}

/* 修复浮动导致的高度塌陷 */
::v-deep .upload_pic.clearfix::after {
  content: '';
  display: table;
  clear: both;
}
</style>
